export default "__VITE_ASSET__bf8b791b__"